// extracted by mini-css-extract-plugin
export var firms = "firms__cWRY";
export var ratingBlock = "ratingBlock__pnqY";